import { render, staticRenderFns } from "./RrcvPD_Items.vue?vue&type=template&id=6d0cd733"
import script from "./RrcvPD_Items.vue?vue&type=script&lang=js"
export * from "./RrcvPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports